module.exports = __webpack_public_path__ + "static/media/user.a0c4ee77.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/user.png
 ** module id = 613
 ** module chunks = 0
 **/